import { useEffect } from 'react';
import { useSelector } from 'react-redux';

export default function DynamicManifest() {
  const { data } = useSelector(state => state.store);

  useEffect(() => {
    if (!data?.empresa) return;

    const empresa = data.empresa;

    // Remove manifest antigo e libera blob URL
    const existingManifest = document.querySelector('link[rel="manifest"]');
    if (existingManifest) {
      const href = existingManifest.getAttribute('href') || '';
      if (href.startsWith('blob:')) URL.revokeObjectURL(href);
      existingManifest.remove();
    }

    // Obtém a URL base da aplicação
    const baseUrl = window.location.origin;

    // Cria manifest dinâmico
    const manifest = {
      name: empresa.nome || "Farmácias",
      short_name: empresa.url ? empresa.url.charAt(0).toUpperCase() + empresa.url.slice(1) : "Farmácias",
      description: empresa.descricao_site || "Os melhores produtos você encontra aqui!",
      theme_color: empresa.cor_primaria || "#00b2a9",
      background_color: empresa.cor_secundaria || empresa.cor_primaria || "#00b2a9",
      display: "standalone",
      orientation: "portrait",
      scope: baseUrl + "/",
      start_url: baseUrl + "/",
      icons: generateIcons(empresa.url, baseUrl)
    };

    // Converte para blob
    const manifestBlob = new Blob([JSON.stringify(manifest)], { type: 'application/json' });
    const manifestURL = URL.createObjectURL(manifestBlob);

    // Adiciona novo manifest
    const link = document.createElement('link');
    link.rel = 'manifest';
    link.href = manifestURL;
    document.head.appendChild(link);

    // Atualiza theme-color meta tag
    updateThemeColor(manifest.theme_color);

    // Atualiza apple-touch-icon
    updateAppleIcon(empresa.url, baseUrl);

    // Atualiza favicon
    updateFavicon(empresa.url, baseUrl);

    console.log(`[Manifest] Carregado para empresa: ${empresa.nome}`);
  }, [data?.empresa]);

  const generateIcons = (empresaUrl, baseUrl) => {
    const sizes = [72, 96, 128, 144, 152, 192, 384, 512];
    const basePath = `/companies/${empresaUrl}/icons`;

    // Verifica se existe pasta de ícones da empresa
    // Caso contrário, usa ícones padrão
    const iconPath = empresaUrl ? basePath : '/icons';

    return sizes.map(size => ({
      src: `${baseUrl}${iconPath}/icon-${size}x${size}.png`,
      sizes: `${size}x${size}`,
      type: "image/png",
      purpose: size >= 192 ? "any maskable" : "any"
    }));
  };

  const updateThemeColor = (color) => {
    let themeColorMeta = document.querySelector('meta[name="theme-color"]');
    if (!themeColorMeta) {
      themeColorMeta = document.createElement('meta');
      themeColorMeta.name = 'theme-color';
      document.head.appendChild(themeColorMeta);
    }
    themeColorMeta.content = color;
  };

  const updateAppleIcon = (empresaUrl, baseUrl) => {
    const appleTouchIcon = document.querySelector('link[rel="apple-touch-icon"]');
    const iconPath = empresaUrl
      ? `/companies/${empresaUrl}/icons/icon-192x192.png`
      : '/icons/icon-192x192.png';

    if (appleTouchIcon) {
      appleTouchIcon.href = `${baseUrl}${iconPath}`;
    } else {
      const link = document.createElement('link');
      link.rel = 'apple-touch-icon';
      link.href = `${baseUrl}${iconPath}`;
      document.head.appendChild(link);
    }
  };

  const updateFavicon = (empresaUrl, baseUrl) => {
    const faviconPath = empresaUrl
      ? `/favicon-${empresaUrl}.ico`
      : '/favicon.ico';

    // Atualiza ou cria link[rel="icon"]
    let iconLink = document.querySelector('link[rel="icon"]');
    if (iconLink) {
      iconLink.href = `${baseUrl}${faviconPath}`;
    } else {
      iconLink = document.createElement('link');
      iconLink.rel = 'icon';
      iconLink.href = `${baseUrl}${faviconPath}`;
      document.head.appendChild(iconLink);
    }

    // Atualiza ou cria link[rel="shortcut icon"]
    let shortcutLink = document.querySelector('link[rel="shortcut icon"]');
    if (shortcutLink) {
      shortcutLink.href = `${baseUrl}${faviconPath}`;
    } else {
      shortcutLink = document.createElement('link');
      shortcutLink.rel = 'shortcut icon';
      shortcutLink.href = `${baseUrl}${faviconPath}`;
      document.head.appendChild(shortcutLink);
    }
  };

  return null;
}
